import { sortBy } from 'lodash';

export default {
  getArticle: (state) => state.article,
  sortedArticles: (state) => sortBy(state.articles, (a) => a.created),
};
